const formCard = {
	el: {
		form: $('.js-form-card'),
		toggleCardNumber: document.querySelector('.js-toggle-field')
	},

	fxToggleManuelCardNumber (input) {
		const inputCardNumber = document.querySelector(`#${input.dataset.target}`),
			inputCardNumberContainer = inputCardNumber.closest('.form__field'),
			select = document.querySelector(`#${input.dataset.fieldToHide}`),
			selectContainer = select.closest('.form__field')
		if(input.checked) {
			inputCardNumberContainer.classList.remove('d-none')
			inputCardNumber.setAttribute('data-rule-required', 'true')
			selectContainer.classList.add('d-none')
			select.removeAttribute('data-rule-required')
			select.classList.contains('field--error') && select.classList.remove('field--error')

			select.nextElementSibling.classList.contains('field--error') && select.nextElementSibling.remove()
		} else {
			selectContainer.classList.remove('d-none')
			select.setAttribute('data-rule-required', 'true')
			inputCardNumberContainer.classList.add('d-none')
			inputCardNumber.removeAttribute('data-rule-required')
			inputCardNumber.classList.contains('field--error') && inputCardNumber.classList.remove('field--error')

			inputCardNumber.nextElementSibling.classList.contains('field--error') && inputCardNumber.nextElementSibling.remove()
		}
	},

	fxFormEvents (el) {
		$.validator.messages = {
			...$.validator.messages,
			required: $(el).data('msg-required')
		}

		el.validate({
			focusInvalid: false,
			invalidHandler (form, validator) {
				if (!validator.numberOfInvalids()) return
		
				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element.closest('.form__field')).offset().top - 20
				}, 200)
			},
			errorClass: 'field--error',
			errorPlacement(error, element) {
				$(element).attr('type') === 'checkbox' ? error.insertAfter($(element).next()) : error.insertAfter(element)
			},
			ignore: '.js-ignore'
		})
	},

	init () {
		if(this.el.form.length === 0) return
		this.fxFormEvents(this.el.form)

		if(this.el.toggleCardNumber !== null) {
			this.el.toggleCardNumber.addEventListener('change', e => {
				this.fxToggleManuelCardNumber(e.currentTarget)
			})
		}
		
		//-rules for form validation
		formValidation.fxValidations(this.el.form)
	}
}

formCard.init()